/*
 * The booking page inside a landing page's form card (lp.remotion.io, desktop).
 * It tells the page around it that it loaded (otherwise the page gives up and
 * goes to /book itself), how tall it is (so the card grows to fit and nothing
 * scrolls inside it), what to bring into view (the frame never scrolls, the
 * page around it does), and that a call was booked. Event names and a height,
 * never the visitor's details, so any origin may hear them.
 */
export const embedded = typeof window !== "undefined" && window.parent !== window;

if (embedded) document.documentElement.classList.add("bk-embedded");

export function tellParent(event, extra) {
  if (!embedded) return;
  try {
    window.parent.postMessage({ source: "remotion-book", event, ...extra }, "*");
  } catch (err) {
    // A parent that cannot be told is a parent with nothing to do.
  }
}

let observer = null;

/** Keep the parent told of our height, from now on. Once per page load. */
export function reportHeight() {
  if (!embedded || observer || typeof ResizeObserver === "undefined") return;
  let last = 0;
  const send = () => {
    // The body, not the document: a document is never shorter than its frame,
    // so the card could grow but never shrink.
    const height = Math.ceil(document.body.getBoundingClientRect().height);
    if (height !== last) tellParent("height", { height: (last = height) });
  };
  // Held at module level: an observer nothing refers to can be collected.
  observer = new ResizeObserver(send);
  observer.observe(document.body);
  send();
}

/** Ask the page around us to scroll until `el` is in view. */
export function showInParent(el) {
  if (!embedded || !el) return;
  const r = el.getBoundingClientRect();
  tellParent("show", { top: Math.floor(r.top), bottom: Math.ceil(r.bottom) });
}
